import styled, { css } from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";

const GenericSideMenuItemIconCommonBox = styled.div<{active?: boolean, useLargeIcon?: boolean}>`
    box-sizing: border-box;
    margin: 0 1rem 0 0;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0 2rem 0 0;
    }

    width: 2.4rem;
    height: 2.4rem;
    padding: 0.2rem;
    transition: color 0.2s ease, background-color 0.2s ease, border-bottom 0.2s ease;
`;

const GenericSideMenuItemIconDefaultBox = styled(GenericSideMenuItemIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${(props) => props.theme.colors.textActive};
        color: ${(props) => props.theme.colors.backgroundDark};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuItemIconCasino888Box = styled(GenericSideMenuItemIconCommonBox)`
    background-color: transparent;
    padding: 0;
    margin-inline-end: 8px;

    width: ${(props) => props.useLargeIcon ? '26px' : '2rem'};
    height: ${(props) => props.useLargeIcon ? '26px' : '2rem'};

    svg {
        width: ${(props) => props.useLargeIcon ? '26px' : '2rem'};
        height: ${(props) => props.useLargeIcon ? '26px' : '2rem'};
    }
`;

const GenericSideMenuItemIconCasino777Box = styled(GenericSideMenuItemIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${({theme}) => theme.colors.backgroundActive};
        color: ${(props) => props.theme.colors.textActive};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuItemIconWsopBox = styled(GenericSideMenuItemIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${(props) => props.theme.colors.logoBackground};
        color: ${(props) => props.theme.colors.textActive};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuItemIconSIBox = styled(GenericSideMenuItemIconCommonBox)`
    color: ${(props) => props.active ? props.theme.colors.textLight : props.theme.colors.textMiddleDark};
`;

const GenericSideMenuItemIconMrGreenBox = styled(GenericSideMenuItemIconCommonBox)`
    ${(props) => props.active ? css`
        color: ${(props) => props.theme.colors.textActive};
        background-color: transparent;
    ` : null}
`;


export const GenericSideMenuItemIconBox = styledByTheme(GenericSideMenuItemIconDefaultBox)
    .forCasino888(GenericSideMenuItemIconCasino888Box)
    .forCasino777(GenericSideMenuItemIconCasino777Box)
    .forWsop(GenericSideMenuItemIconWsopBox)
    .forSI(GenericSideMenuItemIconSIBox)
    .forMrGreen(GenericSideMenuItemIconMrGreenBox)
    .apply();